import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { sparklineSchema } from './sparkline.schema';

const _GetAlertsPerResidentRequestDtoSchema = z.object({
  /**
   * Omit for Portfolio Mode (every facility the user can see); pass an id to scope to one
   * facility.
   */
  facilityId: z.string().optional(),
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetAlertsPerResidentResponseDtoSchema = z.object({
  alertsPerResident: z.number().nullable(),
  changePct: z.number().nullable(),
  sparkline: sparklineSchema,
});

export type GetAlertsPerResidentRequestDto = z.infer<
  typeof _GetAlertsPerResidentRequestDtoSchema
>;

export type GetAlertsPerResidentResponseDto = z.infer<
  typeof GetAlertsPerResidentResponseDtoSchema
>;

export const getAlertsPerResident = (
  params: GetAlertsPerResidentRequestDto,
  config?: AxiosRequestConfig<GetAlertsPerResidentRequestDto>
) => {
  const { facilityId, ...query } = params;

  const url = facilityId
    ? `facilities/${facilityId}/alerts-per-resident`
    : 'facilities/alerts-per-resident';

  return api
    .get(url, { params: query, ...config })
    .then(responseContract(GetAlertsPerResidentResponseDtoSchema));
};
